import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

import { actions as paymentActions } from 'features/payment';

const useBithidePayment = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    rate,
    agentCommission,
  } = useSelector(state => state.payment);

  const [values, setValues] = useState({
    usdtAmount: undefined,
    tndAmount: undefined,
    step: 1,
  });

  useEffect(() => {
    dispatch(paymentActions.getCurrencyRate());
  }, [dispatch]);

  const onUsdtAmountChange = useCallback(val => {
    const newTndAmount = Number((Number(val) * rate) / agentCommission).toFixed(2).replace(',', '.');
    setValues(ps => ({
      ...ps,
      tndAmount: newTndAmount,
      usdtAmount: val,
    }))
  }, [rate, agentCommission]);

  const onDepositInit = useCallback(() => {
    dispatch(paymentActions.depositInit({
      requestData: {
        fromCurrency: 'USDT-TRC20',
        toCurrency: 'TND',
        fromCurrencyAmount: values.usdtAmount,
      },
      callback: () => setValues(ps => ({ ...ps, step: 2 })),
    }))
  }, [values.usdtAmount, dispatch]);

  const onPaidClick = useCallback(id => {
    dispatch(paymentActions.getDepositInfo({
      requestData: { depositId: id },
      callback: () => {
        history.push(`/payment/bithide/${id}`);
        setValues(ps => ({ ...ps, step: 1 }));
      }
    }))
  }, [dispatch, history]);
  
  const onCancelClick = useCallback(() => {
    setValues(ps => ({ ...ps, step: 1 }));
  }, []);

  return useMemo(() => ({
    values,
    onUsdtAmountChange,
    onDepositInit,
    onPaidClick,
    onCancelClick,
  }), [
    values,
    onUsdtAmountChange,
    onDepositInit,
    onPaidClick,
    onCancelClick,
  ]);
};

export default useBithidePayment;
